import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { InfoPaper } from '../common/basic/InfoPaper';
import { ReadOnlyField } from '../common/basic/ReadOnlyField';
import { ShowResourceContent } from '../ShowResourceContent';
import { joinStrings } from '../../utils/format';
import { resources } from '@api/resources';
import { supplierService } from '@api/services/services';
import { SupplierBasicDto } from '@api/models/suppliers/SupplierBasicDto';

interface SupplierBasicInfoProps {
  supplierId: string;
}

/**
 * Read-only supplier summary (name, IDs, address). Used where a full editable
 * SupplierDetail is not available, e.g. an external user viewing a subcontractor.
 */
export const SupplierBasicInfo: FC<SupplierBasicInfoProps> = ({ supplierId }) => {
  const { t } = useTranslation();
  const [supplier, setSupplier] = useState<SupplierBasicDto>();

  useEffect(() => {
    supplierService.getSupplierBasic(supplierId).then((res) => setSupplier(res.data));
  }, [supplierId]);

  const address = supplier?.address;

  return (
    <ShowResourceContent resource={resources.getSupplierBasic}>
      <InfoPaper title={supplier?.name}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <ReadOnlyField label={t('supplier.ico')} valueSx={{ fontWeight: 500 }}>
            {supplier?.ico || '—'}
          </ReadOnlyField>
          <ReadOnlyField label={t('supplier.vat')} valueSx={{ fontWeight: 500 }}>
            {supplier?.vat || '—'}
          </ReadOnlyField>
          <ReadOnlyField label={t('address.title')} valueSx={{ fontWeight: 500 }}>
            {joinStrings(address?.street, address?.city, address?.postalCode, address?.country) || '—'}
          </ReadOnlyField>
        </Box>
      </InfoPaper>
    </ShowResourceContent>
  );
};
